import { call, put } from '@redux-saga/core/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { plantInfo } from 'models';
import { takeLatest } from 'redux-saga/effects';
import { plantApi } from '../../../api/plantApi';
import { sidebarActions } from './sidebarSlice';

function* fetchSidebarListSaga(action: PayloadAction<string>) {
  try {
    const response: plantInfo[] = yield call(plantApi.getPlantsByUserId, action.payload);
    yield put(sidebarActions.fetchSidebarListSuccess(response));
  } catch (error) {
    yield put(sidebarActions.fetchSidebarListFailed('fetch Sidebar list failed'));
  }
}

export default function* sidebarSaga() {
  yield takeLatest(sidebarActions.fetchSidebarList, fetchSidebarListSaga);
}
